/* istanbul ignore file */
import React from 'react';
import SingleBudgetBreadcrumbs from 'domain/finance/budget/shared/SingleBudgetBreadcrumbs';
import { UpdateBreadcrumbItem } from 'framework/ui/BreadCrumbs';

const UpdateBudgetBreadcrumbs = () => {
  return (
    <SingleBudgetBreadcrumbs>
      <UpdateBreadcrumbItem />
    </SingleBudgetBreadcrumbs>
  );
};

export default UpdateBudgetBreadcrumbs;
